const companies = [
  { name: "Crunchyroll", url: "https://www.crunchyroll.com/" },
  { name: "Castle", url: "https://castle.xyz/" },
  { name: "Sketchy", url: "https://www.sketchy.com/" },
  { name: "SmartDreams", url: "https://smartdreams.ai/" },
  { name: "Onibi", url: "https://www.onibi.gg/" },
  { name: "Kartoon Studios", url: "https://www.kartoonstudios.com/" },
  { name: "Together", url: "https://togetherapp.com/" },
  { name: "Find My Meds", url: "https://findmymedsapp.com/" },
  { name: "Stackin", url: "https://www.startstackin.com/" },
  { name: "Marco Polo", url: "https://www.marcopolo.me/" },
  { name: "GameSpot", url: "https://www.gamespot.com/" },
  { name: "Utoppia", url: "https://www.utoppia.com/" },
  { name: "Reveri", url: "https://www.reveri.com/" },
];

// Duplicate for seamless infinite scroll
const doubled = [...companies, ...companies];

const LogoBar = () => {
  return (
    <section className="section-padding-sm bg-secondary border-y border-border overflow-hidden">
      <div className="content-max">
        <p className="text-xs font-body uppercase tracking-[0.2em] text-muted-foreground text-center mb-10">
          Companies I've Helped Scale
        </p>
      </div>

      {/* Marquee track */}
      <div className="relative w-full overflow-hidden">
        {/* Fade edges */}
        <div className="pointer-events-none absolute left-0 top-0 h-full w-24 z-10"
          style={{ background: "linear-gradient(to right, hsl(var(--secondary)), transparent)" }} />
        <div className="pointer-events-none absolute right-0 top-0 h-full w-24 z-10"
          style={{ background: "linear-gradient(to left, hsl(var(--secondary)), transparent)" }} />

        <div className="flex w-max animate-marquee">
          {doubled.map((company, i) => (
            <a
              key={i}
              href={company.url}
              target="_blank"
              rel="noopener noreferrer"
              className="mx-8 md:mx-12 font-body text-sm md:text-base text-foreground/50 hover:text-foreground/90 transition-colors duration-300 whitespace-nowrap"
            >
              {company.name}
            </a>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default LogoBar;